import { ConsumerState } from '@app/resources/ngrx/states';
import { nonConsumerAdapter } from '@app/resources/ngrx/adapters';
import { createReducer, on } from '@ngrx/store';
import { NonConsumerActions } from '@app/resources/ngrx/actions/non-consumer.actions';
import * as fromNonConsumerAdapter from '@app/resources/ngrx/adapters';

export const initialNonConsumerModuleState: ConsumerState = nonConsumerAdapter.getInitialState({
  selectedConsumerId: null,
  selectId: 0,
  hasLoaded: false,
});

export const _nonConsumerReducer = createReducer(
  initialNonConsumerModuleState,
  on(NonConsumerActions.loadNonConsumersSuccess, (state, { payload }) => {
    state = fromNonConsumerAdapter.nonConsumerAdapter.removeAll({ ...state });
    return {
      ...fromNonConsumerAdapter.nonConsumerAdapter.addMany(payload.consumers, state),
      hasLoaded: true,
    };
  }),
  on(NonConsumerActions.upsertNonConsumer, (state, { payload }) => {
    return fromNonConsumerAdapter.nonConsumerAdapter.upsertOne(payload.consumer, state);
  }),
  on(NonConsumerActions.upsertNonConsumers, (state, { payload }) => {
    return fromNonConsumerAdapter.nonConsumerAdapter.upsertMany(payload.consumers, state);
  }),
  on(NonConsumerActions.nonConsumerById, (state, { payload }) => {
    return Object.assign({
      ...state,
      selectedConsumerId: payload.consumerId,
    });
  })
);
